export const toggleLoading = (loading: boolean) => {
  return { type: 'LOADING', payload: loading }
}
